import { render, staticRenderFns } from "./partnerView.vue?vue&type=template&id=2f05e5c4&"
import script from "./partnerView.vue?vue&type=script&lang=js&"
export * from "./partnerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports